import {
  competitionListTimeEnum,
  EuroOrderByOptions,
  ListRenderValues,
  TabTypes,
} from "app/utils/const";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
export class CompetitionHelper {
  static getEuroParams(
    rootState: Record<string, any>,
    payload: { fullList: boolean }
  ) {
    // UI has filters
    // API takes params
    // The following takes the filters to generate the params needed

    // Collect filter values to be used to determine params
    const type = rootState.competitionsListFiltersModel.type;
    const time = rootState.competitionsListFiltersModel.time;
    const bookmarksOnly = rootState.competitionsListFiltersModel.bookmarksOnly;
    const futures = rootState.competitionListModel.futures;
    const fullList = payload.fullList;
    const expandedCompetitionEvents =
      rootState.competitionsListFiltersModel.expandedCompetitionEvents;

    const expandedCompetitionIds = !isEmpty(expandedCompetitionEvents)
      ? expandedCompetitionEvents.map(String).join(",")
      : "";

    const nodes = rootState.navigationModel.navigationNodeIds;
    let navigationNodeIds: string | null = null;
    if (nodes?.length > 0) {
      navigationNodeIds = nodes.join(",");
    }

    // Params to be returned
    if (bookmarksOnly) {
      return {
        bookmarksOnly: true,
        orderBy: EuroOrderByOptions.ALPHABETICAL,
        after: dayjs().startOf("day").unix(),
        size: 180,
      };
    } else if (futures) {
      return {
        size: fullList ? 180 : ListRenderValues.THRESHOLD,
        page: 0,
      };
    } else {
      const orderBy = this.getOrderBy(type);
      const nbEventsByCompetition: number =
        type === TabTypes.ALL ? 50 : type === TabTypes.POPULAR ? 5 : 4;
      const endOfDay: number = dayjs().endOf("day").add(4.5, "hours").unix();
      const before =
        type === TabTypes.ALL && time === competitionListTimeEnum.TODAY
          ? endOfDay
          : null;
      const after =
        type === TabTypes.ALL && time === competitionListTimeEnum.EARLY
          ? endOfDay
          : null;
      return {
        orderBy,
        nbEventsByCompetition,
        before,
        after,
        navigationNodeIds,
        size: fullList ? 180 : ListRenderValues.THRESHOLD,
        page: 0,
        expandedCompetitionIds:
          type === TabTypes.POPULAR && expandedCompetitionIds
            ? expandedCompetitionIds
            : null,
      };
    }
  }
  static getOrderBy(type: string) {
    switch (type) {
      case TabTypes.LIVE:
        return EuroOrderByOptions.LIVE;
      case TabTypes.POPULAR:
        return EuroOrderByOptions.POPULARITY;
      case TabTypes.ALL:
        return EuroOrderByOptions.DATE;
      default:
        return EuroOrderByOptions.POPULARITY;
    }
  }
  static endOfDay = dayjs().endOf("day").add(4.5, "hours").unix();
  static getBeforeParam(time, selectedDate) {
    if (time === competitionListTimeEnum.TODAY) {
      return this.endOfDay;
    } else if (
      time === competitionListTimeEnum.EARLY &&
      selectedDate !== TabTypes.ALL
    ) {
      const endOfSelectedDay = dayjs(selectedDate)
        .endOf("day")
        .add(4.5, "hours")
        .unix();
      return endOfSelectedDay;
    } else {
      return null;
    }
  }
  static getAfterParam(time, selectedDate, asianPreGameEventsOnly) {
    if (
      time === competitionListTimeEnum.EARLY &&
      selectedDate === TabTypes.ALL
    ) {
      return this.endOfDay;
    } else if (
      time === competitionListTimeEnum.EARLY &&
      selectedDate !== TabTypes.ALL
    ) {
      const startOfSelectedDay = dayjs(selectedDate)
        .startOf("day")
        .add(4.5, "hours")
        .unix();
      return startOfSelectedDay;
    } else if (!asianPreGameEventsOnly) {
      return null;
    }
  }
}
